document.addEventListener("DOMContentLoaded", (event) => {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  function updateHighlightProducts() {
    
    document.querySelectorAll(".product-tile__container").forEach(tile => {
      const imgs = tile.querySelectorAll(".product-tile__media figure img");

      const defaultSources = Array.from(imgs).map(img => img.src);

      tile.querySelectorAll(".variant-highlight").forEach(icon => {
        if (icon.dataset.bound === "1") return;
        icon.dataset.bound = "1";

        // --- Lazy preloading of variant images ---
        const preloadImages = [
          icon.dataset.productVariantFirstImg,
          icon.dataset.productVariantSecondImg
        ].filter(Boolean);

        const lazyPreload = () => {
          if (!preloadImages.length) return;
          console.groupCollapsed(`Preloading highlight variant for ${icon.dataset.productVariantId || '(unknown)'}`);
          preloadImages.forEach(src => {
            const img = new Image();
            img.loading = 'eager';
            img.src = src;
            img.onload = () => console.log('Cached', src);
            img.onerror = () => console.warn('Failed to preload', src);
            console.log('Preloading', src);
          });
          console.groupEnd();
        };

        // delayed lazyPreload start
        setTimeout(() => {
          
          if ('requestIdleCallback' in window) {
            // console.log(`Queued preload for ${icon.dataset.productVariantId || '(unknown)'} (will run when browser idle)`);
            requestIdleCallback(lazyPreload, { timeout: 2000 });
          } else {
            // console.log(`Fallback preload scheduled for ${icon.dataset.productVariantId || '(unknown)'} (after 1s timeout)`);
            setTimeout(lazyPreload, 1000);
          }
        }, 4000);

        if (isTouch) {
          let startX = 0, startY = 0, moved = false;

          icon.addEventListener("touchstart", e => {
            const t = e.touches[0];
            startX = t.clientX;
            startY = t.clientY;
            moved = false;
          }, { passive: true });

          icon.addEventListener("touchmove", e => {
            const t = e.touches[0];
            const dx = Math.abs(t.clientX - startX);
            const dy = Math.abs(t.clientY - startY);
            if (dx > 10 || dy > 10) moved = true; // detect swipe
          }, { passive: true });

          icon.addEventListener("touchend", e => {
            if (moved) return; // ignore swipe
            e.preventDefault();
            e.stopPropagation();

            // only here we apply active class
            icon.parentElement?.querySelectorAll(".variant-highlight.active").forEach(el => {
              el.classList.remove("active");
            });
            icon.classList.add("active");

            handleVariantChange(icon, tile, imgs);
          }, { passive: false });

          icon.addEventListener("click", e => e.preventDefault());
        } else {
          icon.addEventListener("mouseenter", () => {
            icon.parentElement?.querySelectorAll(".variant-highlight.active").forEach(el => {
              el.classList.remove("active");
            });
            icon.classList.add("active");
            handleVariantChange(icon, tile, imgs);
          });
        }
      });
    });
  }

  function handleVariantChange(icon, tile, imgs) {
    const newSources = [
      icon.dataset.productVariantFirstImg,
      icon.dataset.productVariantSecondImg
    ];

    imgs.forEach((oldImg, idx) => {
      const newSrc = newSources[idx];
      if (!newSrc || oldImg.src === newSrc) return;

      const preload = new Image();
      preload.src = newSrc;
      preload.onload = () => {
        const overlay = document.createElement("img");
        overlay.src = newSrc;
        overlay.className = "crossfade";
        oldImg.parentElement.appendChild(overlay);

        gsap.to(overlay, {
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          onComplete: () => {
            oldImg.src = newSrc;
            oldImg.removeAttribute("srcset");
            overlay.remove();
          }
        });
      };
    });

    const priceEl = tile.querySelector(".product-tile__meta .product-tile-meta__price");
    if (priceEl && icon.dataset.productVariantPrice) {
      priceEl.innerHTML = icon.dataset.productVariantPrice;
    }

    if (icon.dataset.productVariantUrl) {
      const mediaLink = tile.querySelector("a.product-tile__media");
      if (mediaLink) mediaLink.href = icon.dataset.productVariantUrl;

      const titleLink = tile.querySelector("a.product-tile-meta__title");
      if (titleLink) titleLink.href = icon.dataset.productVariantUrl;
    }

    if (icon.dataset.productVariantDescription) {
      const descEl = tile.querySelector('.product-tile-short-description');
      if (descEl) {
        const cleanDesc = icon.dataset.productVariantDescription
          .replace(/^<p[^>]*>/i, '')
          .replace(/<\/p>$/i, '');
        descEl.innerHTML = `<p>${cleanDesc}</p>`;
      }
    }
  }

  const LIMIT = 5;
  const MOBILE_MAX_WIDTH = 1025; 

  function applyViewMoreBehavior() {
    
    if (window.innerWidth < MOBILE_MAX_WIDTH) return;

    document.querySelectorAll('.variant-thumbnails').forEach(container => {

      // Collect both types of variants
      const items = Array.from(container.querySelectorAll('a.variant-highlight'));
      if (items.length <= LIMIT) return; // nothing to hide

      // Remove any existing "+N" label
      container.querySelector('.variant-more')?.remove();

      // Hide items beyond LIMIT
      items.forEach((item, i) => {
        if (i >= LIMIT) item.style.display = 'none';
      });

      // Create "+N" label
      const hiddenCount = items.length - LIMIT;
      const moreLabel = document.createElement('div');
      moreLabel.className = 'variant-more';
      moreLabel.textContent = `+${hiddenCount}`;
      container.appendChild(moreLabel);

      // Click → instantly reveal all hidden items
      const moreLabelEvent = isTouch ? 'touchstart' : 'mouseenter';
      moreLabel.addEventListener(moreLabelEvent, () => {
        items.forEach(item => (item.style.display = 'inline-block'));
        moreLabel.remove();
      });
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      updateHighlightProducts();
      applyViewMoreBehavior();
    }, 200); // runs once, 200ms after user stops resizing
  });

  const highlightorigFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    if (typeof url === "string" && url.includes("/collections/")) {
      // console.log("Fetching collection products:", url);
    }
    return highlightorigFetch.apply(this, arguments).then(res => {
      if (res.url.includes("/collections/")) {
        // console.log("Collection products fetched:", res.url);
        setTimeout(()=>{
          updateHighlightProducts();
          applyViewMoreBehavior();
        }, 100)
      }
      return res;
    });
  };

});
